import { formatPhoneNumber, formatAmount } from "../../../../utils/appUtils";
import dayjs from "dayjs";

const rowStyle = { margin: 0, padding: "5px 0" };

export const couponActionDropdownMenu = [
    { key: "viewProfile", label: "View Profile" },
    { key: "sendCoupons", label: "Send Coupons" }
];

export const offersActionDropdownMenu = [
    { key: "editOffer", label: "Edit Offer" },
    { key: "viewImage", label: "View Image" },
    { key: "closeOffer", label: "Close Offer" }
];

export const couponsHistoryActionDropdownMenu = [
    { key: "editCoupon", label: "Edit" },
    { key: "deleteCoupon", label: "Delete" }
];

export const COUPON_COLUMNS = (actionRender) => [
    {
        title: "SNo",
        width: 60,
        align: "center",
        render: (_, detail, index) => <>{index + 1}</>
    },
    {
        title: "Customer Name",
        dataIndex: "customerName",
        key: "customerName",
        align: "center",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Mobile number",
        dataIndex: "mobileNumber",
        key: "mobileNumber",
        align: "center",
        render: (text) => <p style={rowStyle}>{formatPhoneNumber(text) || "Nil"}</p>
    },
    {
        title: "Customer ID",
        dataIndex: "customerNo",
        key: "customerNo",
        align: "center",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Total Recharge",
        dataIndex: "totalRecharge",
        key: "totalRecharge",
        align: "center",
        render: (text) => <p style={rowStyle}>{`₹${formatAmount(text || 0)}`}</p>
    },
    {
        title: "Total Cons.",
        dataIndex: "totalCountConsultation",
        key: "totalCountConsultation",
        align: "center",
        render: (text) => <p style={rowStyle}>{text || 0}</p>
    },
    {
        title: "Total Refund Amount",
        dataIndex: "totalRefundAmount",
        key: "totalRefundAmount",
        align: "center",
        render: (text) => <p style={rowStyle}>{`₹${formatAmount(text || 0)}`}</p>
    },
    {
        title: "Action",
        width: 50,
        fixed: "right",
        align: "center",
        render: (list) => actionRender(list)
    }
];

export const OFFERS_HISTORY_COLUMNS = (actionRender) => [
    {
        title: "SNo",
        width: 60,
        align: "center",
        render: (_, detail, index) => <>{index + 1}</>
    },
    {
        title: "Offer Name",
        dataIndex: "discountName",
        key: "discountName",
        align: "center",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Start Date",
        dataIndex: "startDate",
        key: "startDate",
        align: "center",
        render: (text) => <p style={rowStyle}>{text ? dayjs(text).format("DD/MM/YYYY") : "Nil"}</p>
    },
    {
        title: "End Date",
        dataIndex: "endDate",
        key: "endDate",
        align: "center",
        render: (text) => <p style={rowStyle}>{text ? dayjs(text).format("DD/MM/YYYY") : "Nil"}</p>
    },
    {
        title: "Offers %",
        dataIndex: "discountPercentage",
        key: "discountPercentage",
        align: "center",
        render: (text) => <p style={rowStyle}>{text ? `${text}%` : "Nil"}</p>
    },
    {
        title: "User Count",
        dataIndex: "usedCount",
        key: "usedCount",
        align: "center",
        render: (text) => <p style={rowStyle}>{text || 0}</p>
    },
    {
        title: "Action",
        width: 50,
        fixed: "right",
        align: "center",
        render: (list) => actionRender(list)
    }
];

export const COUPONS_HISTORY_COLUMNS = (page, size, actionRender) => [
    {
        title: "SNo",
        width: 60,
        align: "center",
        render: (_, detail, index) => <>{page * size + index + 1}</>
    },
    {
        title: "Create Date",
        dataIndex: "createDate",
        width: 110,
        key: "createDate",
        align: "center",
        render: (text) => <p style={rowStyle}>{text ? dayjs(text).format("DD/MM/YYYY") : "Nil"}</p>
    },
    {
        title: "Start Date",
        dataIndex: "validFrom",
        width: 110,
        key: "startDate",
        align: "center",
        render: (text) => <p style={rowStyle}>{text ? dayjs(text).format("DD/MM/YYYY") : "Nil"}</p>
    },
    {
        title: "End Date",
        width: 110,
        dataIndex: "validTo",
        key: "endDate",
        align: "center",
        render: (text) => <p style={rowStyle}>{text ? dayjs(text).format("DD/MM/YYYY") : "Nil"}</p>
    },
    {
        title: "Coupon Code",
        dataIndex: "couponCode",
        width: 150,
        key: "couponCode",
        align: "center",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Description",
        dataIndex: "description",
        width: 200,
        key: "description",
        align: "center",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Offer %",
        width: 100,
        dataIndex: "couponPercentage",
        key: "couponPercentage",
        align: "center",
        render: (text) => <p style={rowStyle}>{text ? `${text}%` : "Nil"}</p>
    },
    {
        title: "Created By",
        width: 150,
        dataIndex: "generateByName",
        key: "generateByName",
        align: "center",
        render: (text) => <p style={rowStyle}>{text || "Nil"}</p>
    },
    {
        title: "Usage",
        dataIndex: "used",
        key: "used",
        width: 120,
        align: "center",
        render: (text) => {
            const isUsed = text === true || text === "true";
            return (
                <div style={rowStyle}>
                    <div className={isUsed ? "success-status" : "danger-status"}>
                        ● {isUsed ? "Used" : "Unused"}
                    </div>
                </div>
            );
        }
    },
    {
        title: "Status",
        dataIndex: "couponStatus",
        key: "couponStatus",
        width: 120,
        align: "center",
        render: (status) => {
            const isActive = status === "ACTIVE";
            return (
                <div style={rowStyle}>
                    <div className={isActive ? "success-status" : "danger-status"}>
                        {status}
                    </div>
                </div>
            );
        }
    },
    {
        title: "Actions",
        width: 50,
        fixed: "right",
        align: "center",
        render: (list) => actionRender ? actionRender(list) : null
    }
];